export default __webpack_public_path__ + "static/media/hmd_xl2.d845d6ae.png";